import { getDefaultOptions as m } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getDefaultOptions.js";
function s(o, n, e) {
  var a;
  const t = m(), r = u(o, e.timeZone, (a = e.locale) != null ? a : t.locale);
  return "formatToParts" in r ? i(r, n) : f(r, n);
}
function i(o, n) {
  const e = o.formatToParts(n);
  for (let t = e.length - 1; t >= 0; --t)
    if (e[t].type === "timeZoneName")
      return e[t].value;
}
function f(o, n) {
  const e = o.format(n).replace(/\u200E/g, ""), t = / [\w-+ ]+$/.exec(e);
  return t ? t[0].substr(1) : "";
}
function u(o, n, e) {
  return new Intl.DateTimeFormat(e ? [e.code, "en-US"] : void 0, {
    timeZone: n,
    timeZoneName: o
  });
}
export {
  s as tzIntlTimeZoneName
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/_lib/tzIntlTimeZoneName/index.js
// module id = 1374
// module chunks = 67